import styled from 'styled-components';
import {device} from 'styled/device';
import StandardModalSheet from 'components/common/StandardModalSheet';
import ModalSheet from 'components/common/ModalSheet';

export const StyledLogoutModalSheet = styled(StandardModalSheet)`
  padding: 0;
  .modal-sheet__title {
    margin-bottom: 24px;
  }

  .standard-modal-sheet__text {
    padding: 0 24px;

    @media (min-width: ${device.tablet}) {
      padding: 0 10px;
    }
  }

  & .standard-modal-sheet__button {
    width: 100%;

    @media (min-width: ${device.tablet}) {
      margin-bottom: 0;

      .standard-modal-sheet__text {
        padding: 0 104px;
      }
    }
  }
`;

export const StyledModalSheet = styled(ModalSheet)`
  &-content {
    max-width: 327px;
  }
`;
